import React from "react";
import {
  Grid,
  withStyles,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { Link } from "react-router-dom";

import Stats from "../../components/Stats/ScopedStatsController";
import { headerIcon, tab } from "../../bento/studyDetailData";
import Tab from "../../components/Tab/Tab";
import TabPanel from "../../components/Tab/TabPanel";
import Styles from "./studyDetailsStyle";
import StudyThemeProvider from "./studyDetailsThemeConfig";
import Overview from "./views/overview/overview";
import { onClearAllAndSelectFacetValue } from "../dashTemplate/sideBar/BentoFilterUtils";
import useDashboardTabs from "../dashTemplate/components/dashboard-tabs-store";
import ClinicalDataController from "./views/clinical-data/ClinicalDataController";
import StudyFilesView from "./views/study-files/StudyFilesView";
import PublicationsView from "./views/publications/PublicationsView";
import CustomBreadcrumb from "../../components/Breadcrumb/BreadcrumbView";
const StudyDetailView = ({
  classes,
  data,
  study_id,
  isLoading = false,
  isError = false,
}) => {
  const studyData = data;
  const processedTabs = tab.items;
  const study_short_name =
    studyData?.studyByStudyShortName?.at(0)?.study_short_name;
  const zipFileData = data?.studyZipFileQuery || [];

  const breadCrumbJson = [
    { name: "Studies", to: "/studies", isALink: true },
    { name: study_short_name + "." + study_id, to: "", isALink: false },
  ];

  const [, actions] = useDashboardTabs();

  const [currentTab, setCurrentTab] = React.useState(0);
  const handleTabChange = (event, value) => {
    setCurrentTab(value);
  };

  const getHeaderIcon = () => (
    <img src={headerIcon} alt="CTDC Study detail header logo" />
  );

  if (isLoading) {
    return <CircularProgress />;
  }

  if (isError) {
    return (
      <Typography variant="h5" color="error" size="sm">
        An error has occurred in interoperability api
      </Typography>
    );
  }

  const linkToDashboard = () => {
    // TODO: Once local-find is enabled; dispatch(resetAllData()) from bento-core/local-find to RESET_LOCALFIND_ALL_DATA
    onClearAllAndSelectFacetValue("study_short_name", study_short_name);
    actions.changeCurrentTab(0);
  };

  const clinicalDataNodeCounts = {
    ...data?.clinicalDataNodeCounts?.at(0),
    ...data?.clinicalTrialDataNodeCounts?.at(0),
  };
  const clinicalDataNodeParticipantCounts = {
    ...data?.clinicalDataParticipantCounts?.at(0),
    ...data?.clinicalTrialDataParticipantCounts?.at(0),
  };

  return (
    <StudyThemeProvider>
      <Stats variables={{ study_short_name: [study_short_name] }} />

      <div className={classes.container}>
        <div className={classes.breadCrumb}>
          <CustomBreadcrumb separator=">" data={breadCrumbJson} />
        </div>
        <div className={classes.header}>
          <div className={classes.logo}>{getHeaderIcon()}</div>
          <div className={classes.headerTitle}>
            <div className={classes.headerMainTitle}>
              <span>
                {studyData.studyByStudyShortName[0].study_short_name}&nbsp;{">"}
                <span className={classes.headerMainSubTitle}>
                  {studyData.studyByStudyShortName[0].study_id}
                </span>
              </span>
            </div>
            <div className={classes.headerSubTitleCate}>
              <span>{studyData.studyByStudyShortName[0].study_name}</span>
            </div>
          </div>
          <div className={classes.headerButton}>
            <span className={classes.headerButtonLinkSpan}>
              <Link
                className={classes.headerButtonLink}
                to={(location) => ({ ...location, pathname: "/explore" })}
                onClick={() => linkToDashboard()}
              >
                <div className={classes.headerButtonLinkNumber}>
                  {studyData.studyByStudyShortName[0].participant_count || 0}
                </div>
                <span className={classes.headerButtonLinkText}>
                  Associated Participants
                </span>
              </Link>
            </span>
          </div>
        </div>

        <div className={classes.detailContainer}>
          <Grid container>
            <Grid item xs={12}>
              <Tab
                styleClasses={classes}
                tabItems={processedTabs}
                currentTab={currentTab}
                handleTabChange={handleTabChange}
              />
            </Grid>
          </Grid>
        </div>
      </div>
      {processedTabs.map((processedTab, index) => {
        switch (processedTab.value) {
          case "overview":
            return (
              <div key={processedTab.value} hidden={currentTab !== index}>
                <TabPanel value={currentTab} index={index} maxWidth="1800px">
                  <Overview data={data} zipFileData={zipFileData} />
                </TabPanel>
              </div>
            );

          case "clinical_data":
            return (
              <div key={processedTab.value} hidden={currentTab !== index}>
                <TabPanel value={currentTab} index={index} maxWidth="1800px">
                  <ClinicalDataController
                    dataCount={{
                      participantCount: clinicalDataNodeParticipantCounts,
                      nodeCount: clinicalDataNodeCounts,
                    }}
                    study_id={study_id}
                    study_short_name={study_short_name}
                  />
                </TabPanel>
              </div>
            );

          case "study_files":
            return (
              <div key={processedTab.value} hidden={currentTab !== index}>
                <TabPanel value={currentTab} index={index} maxWidth="1800px">
                  <StudyFilesView study_id={study_id} />
                </TabPanel>
              </div>
            );

          case "publications":
            return (
              <div key={processedTab.value} hidden={currentTab !== index}>
                <TabPanel value={currentTab} index={index} maxWidth="1800px">
                  <PublicationsView study_id={study_id} />
                </TabPanel>
              </div>
            );

          default:
            return null;
        }
      })}
    </StudyThemeProvider>
  );
};

export default withStyles(Styles, { withTheme: true })(StudyDetailView);
